/**
 * 크리스마스 이벤트 관련 상수
 *
 * 크리스마스 커서 이모지, 애니메이션 등에 사용되는 상수를 정의합니다.
 */

/** 크리스마스 커서에 사용되는 이모지 배열 */
export const CHRISTMAS_EMOJIS: readonly string[] = [
    "🎁",
    "🎄",
    "🎅",
    "❄️",
    "⛄",
    "🦌",
    "🎄",
    "🎊",
    "🎉",
    "✨",
    "🌟",
    "💫",
    "🎈",
    "🎀",
    "🎁",
    "🎄",
    "🎅",
    "🤶",
    "🧑‍🎄",
    "🎄",
    "🎁",
    "🎄",
    "🎅",
    "❄️",
    "⛄",
    "🦌",
    "🎄",
    "🎊",
    "🎉",
    "✨"
];

/** 크리스마스 커서 localStorage 키 */
export const CHRISTMAS_CURSOR_STORAGE_KEY = "mix_christmas_cursor";

/** 크리스마스 커서 변경 이벤트 이름 */
export const CHRISTMAS_CURSOR_CHANGED_EVENT = "mix_christmas_cursor_changed";
